import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-ethics-review-committee',
  templateUrl: './ethics-review-committee.component.html',
  styleUrls: ['./ethics-review-committee.component.scss']
})
export class EthicsReviewCommitteeComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('Ethics Review Committee')
  }
}
